<template>
    <div>
        <el-card>
            <nav class="input" style="width: auto">
                <el-input
                    v-model="search.keyword"
                    size="medium"
                    placeholder="用户ID/用户名/道具名称"
                    clearable
                    @keyup.enter.native="subimt"
                />
            </nav>
            <nav class="input" style="width: auto">
                <el-select
                    v-model="search.status"
                    placeholder="状态"
                    size="medium"
                    clearable
                >
                    <el-option label="全部" :value="''" />
                    <el-option label="未使用" :value="0" />
                    <el-option label="已过期" :value="1" />
                    <el-option label="已使用" :value="2" />
                    <el-option label="使用中" :value="3" />
                </el-select>
            </nav>
            <nav class="input" style="width: 150px">
                <el-button size="small" @click="reset">重置</el-button>
                <el-button type="primary" size="small" @click="subimt"
                    >搜索</el-button
                >
            </nav>
        </el-card>

        <el-card style="margin-top: 10px">
            <el-table
                :data="list"
                style="width: 100%"
                border
                stripe
                :header-cell-style="rowClass"
            >
                <el-table-column prop="id" label="ID" width="80" />
                <el-table-column prop="userId" label="用户ID" width="110" />
                <el-table-column prop="userName" label="用户名" min-width="100" />
                <el-table-column prop="propName" label="道具名称" min-width="120" />
                <el-table-column label="道具值" width="90">
                    <template slot-scope="{ row }">
                        {{ row.value }}{{ row.valueUnit || '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="statusName" label="状态" width="90">
                    <template slot-scope="{ row }">
                        <el-tag size="mini" :type="statusTagType(row.status)">
                            {{ row.statusName || '-' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="有效期" min-width="160">
                    <template slot-scope="{ row }">
                        {{
                            row.isTerm == 2
                                ? row.isTermName || '永久有效'
                                : row.expireTime || '-'
                        }}
                    </template>
                </el-table-column>
                <el-table-column label="使用时间" min-width="160">
                    <template slot-scope="{ row }">
                        {{ row.useTime || '-' }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="isGiveawayName"
                    label="获取方式"
                    width="110"
                >
                    <template slot-scope="{ row }">
                        {{ row.isGiveawayName || '-' }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="channelName"
                    label="渠道"
                    width="100"
                    show-overflow-tooltip
                >
                    <template slot-scope="{ row }">
                        {{ row.channelName || '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="terminal" label="来源" width="100">
                    <template slot-scope="{ row }">
                        {{ row.terminal || '-' }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="领取时间"
                    width="160"
                />
            </el-table>

            <el-pagination
                :current-page="search.page"
                background
                :page-sizes="[3, 5, 10, 15]"
                :page-size="search.pageSize"
                layout="total, prev, pager, next"
                :total="total"
                @current-change="handleCurrentChange"
            />
        </el-card>
    </div>
</template>

<script>
import list from '/src/mixin/list.js'

export default {
    mixins: [list],
    data() {
        return {
            search: {
                keyword: '',
                status: '',
                page: 1,
                pageSize: 10,
            },
        }
    },
    created() {
        this.getlist()
    },
    methods: {
        statusTagType(status) {
            const map = {
                0: 'success',
                1: 'info',
                2: 'warning',
                3: '',
            }
            return map[status] != null ? map[status] : 'info'
        },
        handleCurrentChange(e) {
            this.search.page = e
            this.getlist()
        },
        async getlist() {
            const { data: res } = await this.$http.get(
                '/admin/CooperationProp/getRecordList',
                {
                    params: {
                        ...this.search,
                    },
                }
            )
            if (res.errorCode == 200) {
                this.list = res.data.list || []
                this.total = res.data.totalCount || 0
            }
        },
        subimt() {
            this.search.page = 1
            this.getlist()
        },
    },
}
</script>

<style lang="less" scoped></style>
